function formsReplaceOldRoot(value) {
  return String(value || "").replace("doimage.workers.dev", "youniq.co.uk");
}

function fixSrcFilestack(value) {
  var source = formsReplaceOldRoot(value);
  if (!/cdn\.filestackcontent\.com/i.test(source)) return source;
  var decoded = source;
  try { decoded = decodeURIComponent(source); } catch (error) {}
  var segments = decoded.replace(/^https?:\/\/cdn\.filestackcontent\.com\//i, "").split("?")[0].split("/");
  var handle = null;
  var rotate = 0;
  var crop = null;
  segments.forEach(function (segment) {
    if (/^[A-Za-z0-9]{20}$/.test(segment)) handle = segment;
    var rotateMatch = segment.match(/^rotate=deg:(-?\d+)$/i);
    if (rotateMatch) rotate = parseInt(rotateMatch[1], 10);
    var cropMatch = segment.match(/^crop=dim:\[?(\d+),(\d+),(\d+),(\d+)\]?$/i);
    if (cropMatch) crop = cropMatch.slice(1).map(function (part) { return parseInt(part, 10); });
  });
  if (!handle) return source;
  var result = new URL("https://fsimg.youniq.co.uk/legacy/" + encodeURIComponent(handle));
  if (rotate) result.searchParams.set("rotate", String(rotate));
  if (crop) result.searchParams.set("crop", crop.join(","));
  return result.toString();
}

function getCustUrl() {
  var cart = $(".cart-item-data").text();
  var encoded = cart.split(":")[1].trim();
  var parsed = JSON.parse(atob(encoded));
  var preview = parsed.find(function (item) { return item.id === "preview"; });
  return fixSrcFilestack(preview.val);
}
